import hoLogo from '../assets/ho_logo_28x24.png';

function Footer() {
  return (
    <footer className="text-xs text-center text-slate-500 border-t border-green-500 p-3 sm:px-0 flex flex-col sm:flex-row gap-4 justify-between">
      <div>
        <span>Developed by Harry Oosterveen,</span>
        <a href="https://www.harryonline.net/" className="italic">
          <span className="px-1">HarryOnline</span>
          <img
            alt="HarryOnline logo"
            src={hoLogo}
            className="h-3 inline-block -translate-y-0.5"
            width="14"
            height="12"
          />
        </a>
      </div>
      <div>
        <span>Sounds from</span>
        <a href="https://notificationsounds.com/" className="underline ms-1" target="_blank">Notification Sounds</a>
      </div>
    </footer>
  );
}

export default Footer;
